import { Logo } from "../components/Logo";
import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";
import { useAuth } from "../auth";
import { useLanguage } from "../i18n";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const lbl = "text-xs uppercase tracking-[0.15em] font-semibold text-inksoft";
const inp = "rounded-sm border-ink/15 focus-visible:ring-amberl h-11";

// Opened from the "Reimposta la password" email: /reset-password?token=...
export default function ResetPasswordPage() {
  const { t } = useLanguage();
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      toast.error(t.auth.resetMismatch);
      return;
    }
    setBusy(true);
    try {
      const res = await axios.post(`${API}/auth/reset-password`, { token, password }, { withCredentials: true });
      setUser(res.data);
      toast.success(t.auth.resetDone);
      navigate("/account");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : t.auth.resetMissing);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-6 py-20">
      <div className="w-full max-w-md">
        <Link to="/" className="flex justify-center text-ink mb-10" aria-label="FArLight">
          <Logo className="h-14 w-auto" accent="#B8875A" />
        </Link>
        <div className="bg-white border border-ink/10 rounded-sm p-10 shadow-[0_8px_30px_rgba(42,39,38,0.06)]">
          <h1 className="font-display text-3xl font-medium text-ink tracking-tight">{t.auth.resetTitle}</h1>
          {!token ? (
            <p role="alert" className="mt-6 text-sm text-inksoft">{t.auth.resetMissing}</p>
          ) : (
            <form onSubmit={submit} className="mt-8 space-y-5">
              <div className="space-y-2">
                <Label htmlFor="reset-password" className={lbl}>{t.auth.newPassword} <span className="normal-case font-normal">({t.auth.minChars})</span></Label>
                <Input id="reset-password" type="password" autoComplete="new-password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className={inp} />
              </div>
              <div className="space-y-2">
                <Label htmlFor="reset-confirm" className={lbl}>{t.auth.confirmPassword}</Label>
                <Input id="reset-confirm" type="password" autoComplete="new-password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inp} />
              </div>
              <button type="submit" disabled={busy} className="w-full bg-ink text-cream hover:bg-espresso disabled:opacity-60 transition-colors rounded-sm h-12 text-xs font-semibold uppercase tracking-[0.15em]">
                {t.auth.resetSave}
              </button>
            </form>
          )}
          <Link to="/login" className="mt-6 block text-center text-sm font-semibold text-amberdark hover:text-ink">{t.auth.backToLogin}</Link>
        </div>
      </div>
    </div>
  );
}
